import { GET, PUT, POST, RAW_DELETE } from "lib/api";

const API_UNITS = "v1/talentmanagement/manager/team-available-units";
const API_TEAM = "v1/teams/";
const API_BASE = "v1/";
const API_PERMISSIONS = "v1/teams/rights";
const API_ADD_TEAM = "v1/team/";
const API_DELETE_TEAM = "v1/team";
const API_UPDATE_TEAM = "v1/teams";
const API_GET_USERS_TABLE_FIELDS = "v1/user/fields";

const ERROR_MESSAGE = "error";

export async function fetchTeams(unitId = 1) {
  let data = await GET(`v1/unit/${unitId}/teams`);
  return data;
}

export async function fetchResponsibleTeams(personalId) {
  let data = await GET(`v1/user/${personalId}/teams`);
  return data;
}

export async function fetchReadOnlyTeams() {
  const data = await GET(`v1/user/hr/teams`);
  return data;
}

export async function fetchCoworkerTeams(personalId) {
  let data = await GET(`v1/teams/coworker/${personalId}`);
  return data;
}

export async function fetchResponsibleUnits() {
  let data = await GET(`v1/talentmanagement/manager/dashboard/available-units`);
  return data;
}

export async function fetchReadOnlyUnits() {
  let data = await GET(`v1/talentmanagement/manager/dashboard/readonly-units`);
  return data;
}

export async function fetchCoworkerUnits(personalId) {
  let data = await GET(`v1/user/${personalId}/units`);
  return data;
}

export async function fetchUnits() {
  let data = await GET(`${API_UNITS}`);
  return data;
}

export async function fetchTeam(teamID) {
  let data = await GET(API_TEAM + teamID);
  return data;
}

export async function fetchUnitCoworkers(unitID, includeSubUnits) {
  let data = await GET(
    `${API_BASE}units/${unitID}/coworkersforteam?subUnits=${includeSubUnits}`,
  );

  return data;
}

export async function fetchPermissions() {
  let data = await GET(API_PERMISSIONS);
  return data;
}

export async function saveTeam(data) {
  let response = await POST(API_ADD_TEAM, {}, data);
  if (response.id) {
    let updatedData = Object.assign({}, data);
    updatedData.teamId = response.id;
    updatedData.id = response.id;

    return updatedData;
  }
  return ERROR_MESSAGE;
}

export async function updateTeam(data) {
  let teamData = await PUT(`${API_UPDATE_TEAM}/${data.teamId}`, {}, data);

  return teamData;
}

export async function deleteTeam(teamID) {
  if (teamID) {
    const deleteResult = await RAW_DELETE(
      `${API_DELETE_TEAM}/${teamID}`,
      {},
      teamID,
    );
    return deleteResult;
  }

  return null;
}

export async function getUserFields() {
  let data = await GET(`${API_GET_USERS_TABLE_FIELDS}`);
  return data;
}
